export const styles = {
  sizes: {
    small: 'max-w-sm',
    medium: 'max-w-md',
    large: 'max-w-xl',
    xl: 'max-w-3xl',
    xxl: 'max-w-4xl',
  }
};
